export default "__VITE_ASSET__BMj9N5HV__"